import { render, staticRenderFns } from "./QuestionOptionsComponent.vue?vue&type=template&id=98d52ce4&"
import script from "./QuestionOptionsComponent.vue?vue&type=script&lang=js&"
export * from "./QuestionOptionsComponent.vue?vue&type=script&lang=js&"
import style0 from "./QuestionOptionsComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports